module.exports = __webpack_public_path__ + "img/Réalisation pergola..7ee9428f.jpg";